import axios from 'axios';

// Phase 3: Central axios client used by services and UI modules.
export const Instance = axios.create({
  baseURL: process.env.REACT_APP_API_SERVER_URL,
});

Instance.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  async (error) => Promise.reject(error)
);

const refreshLegacyToken = async () => {
  const response = await Instance.post('/api/v1/users/auth/refreshToken', {
    refreshToken: localStorage.getItem('refreshToken'),
  });

  const { accessToken, refreshToken } = response.data.data ?? response.data;
  localStorage.setItem('accessToken', accessToken);
  localStorage.setItem('refreshToken', refreshToken);
  return accessToken;
};

Instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response && error.response.status === 401 && error.response.data.error === 'TokenExpiredError') {
      try {
        const accessToken = await refreshLegacyToken();
        originalRequest.headers.Authorization = `Bearer ${accessToken}`;
        return Instance(originalRequest);
      } catch (refreshError) {
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);
